import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import { ptBR } from "date-fns/locale";
import { startOfToday, format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { isPeak, PEAK_FEE, brl } from "@/lib/pricing";

const useMonths = () => {
  const [m, setM] = useState(typeof window !== "undefined" && window.innerWidth >= 768 ? 2 : 1);
  useEffect(() => {
    const on = () => setM(window.innerWidth >= 768 ? 2 : 1);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return m;
};

const fmt = (d) => (d ? format(d, "EEE, dd 'de' MMM yyyy", { locale: ptBR }) : "—");

export const CalendarioReserva = ({ range, setRange }) => {
  const months = useMonths();
  const today = startOfToday();
  return (
    <div data-testid="booking-calendar" className="bg-white p-5 shadow-[0_30px_60px_-30px_rgba(26,56,43,0.35)] sm:p-8">
      <div className="mb-6 grid gap-4 sm:grid-cols-2">
        <div data-testid="booking-checkin-display" className="border-l-2 border-[#7ab51d] pl-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5f6e62]">Check-in</p>
          <p className="mt-1 text-lg font-bold capitalize text-[#1a382b]">{fmt(range?.from)}</p>
        </div>
        <div data-testid="booking-checkout-display" className="border-l-2 border-[#a85d38] pl-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#5f6e62]">Check-out</p>
          <p className="mt-1 text-lg font-bold capitalize text-[#1a382b]">{fmt(range?.to)}</p>
        </div>
      </div>
      <div className="flex justify-center overflow-x-auto" data-testid="booking-calendar-range">
        <DayPicker
          mode="range"
          locale={ptBR}
          numberOfMonths={months}
          selected={range}
          onSelect={setRange}
          disabled={{ before: today }}
          fromMonth={today}
          modifiers={{ peak: (d) => isPeak(d) }}
          modifiersClassNames={{ peak: "rdp-peak" }}
          classNames={{
            months: "flex flex-col gap-8 md:flex-row md:gap-12",
            month: "space-y-4",
            caption: "relative flex items-center justify-center pt-1",
            caption_label: "text-base font-bold capitalize text-[#1a382b]",
            nav: "flex items-center",
            nav_button: "absolute grid h-9 w-9 place-items-center rounded-full border border-[#d9d2c1] text-[#1a382b] transition-colors hover:bg-[#7ab51d]",
            nav_button_previous: "left-0",
            nav_button_next: "right-0",
            table: "w-full border-collapse",
            head_row: "flex",
            head_cell: "w-10 text-[11px] font-normal uppercase text-[#5f6e62] sm:w-11",
            row: "mt-1 flex w-full",
            cell: "relative p-0 text-center",
            day: "relative h-10 w-10 text-sm text-[#263228] transition-colors hover:bg-[#e7efd6] sm:h-11 sm:w-11",
            day_selected: "!bg-[#1a382b] !text-[#f3efe4]",
            day_range_middle: "rdp-mid",
            day_today: "font-bold underline decoration-[#7ab51d] decoration-2 underline-offset-4",
            day_disabled: "!text-[#b9b3a5] hover:!bg-transparent cursor-not-allowed",
            day_outside: "invisible",
          }}
        />
      </div>
      <p className="mt-6 flex items-start gap-2 text-sm text-[#3d4a34]">
        <CalendarDays className="mt-0.5 h-4 w-4 shrink-0 text-[#a85d38]" />
        <span>
          <span className="mr-1 inline-block h-2 w-2 rounded-full bg-[#a85d38] align-middle" /> Datas especiais (24/12, 25/12, 31/12 e 01/01): acréscimo de{" "}
          {brl(PEAK_FEE)} por diária.
        </span>
      </p>
    </div>
  );
};
